import { render } from "./UserProfile.vue?vue&type=template&id=98e14d38"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"
script.render = render

export default script